// src/pages/TermsPage.tsx
import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import PageHeader from '@/components/PageHeader';
// Import the markdown content directly
import termsMarkdown from '@/data/terms.md?raw';

const TermsPage = () => {
  // Instead of fetching, we can use the imported markdown directly
  const content = termsMarkdown;

  return (
    <div>
      {/* Use the PageHeader component */}
      <PageHeader
        title="Terms & Conditions"
        description="Please read these terms carefully before using our services"
      />

      <div className="container mx-auto px-4">
        <motion.div
          className="max-w-full mx-auto bg-white rounded-lg shadow-sm py-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}>
          <div className="prose prose-lg max-w-none prose-headings:text-primary prose-a:text-secondary">
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </motion.div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-40">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Questions about our terms?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            If you have any questions or need clarification about our Terms and
            Conditions, our team is here to help.
          </p>
          <a
            href="/contact"
            className="bg-secondary hover:bg-secondary/90 text-white font-semibold py-3 px-8 rounded-full inline-block transition-colors">
            Contact Us
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
